<template>
    <div
        class="page"
        v-if="order">
        <div class="order">
            <OrderCard
                class="order__card"
                :order="order"
            />
        </div>
        <div
            class="insurance-confirmation"
            v-if="hasOptedInInsurance">
            <div class="insurance-confirmation__logo">
                <allianz-logo class="allianz-logo" />
            </div>
            <div class="insurance-confirmation__info">
                <p>
                    Thank you for choosing Allianz to insure your experience. You will receive a separate email providing
                    you an update around the status of your policy purchase within the next 24 hours.
                </p>
            </div>
        </div>
        <div v-if="trackingPixelHtml" v-html="trackingPixelHtml"></div>
        <iframe
            v-if="isCjTrackingPixel"
            height="1"
            width="1"
            frameborder="0"
            scrolling="no"
            :src="`https://www.emjcd.com/tags/c?`
                + `containerTagId=${encodeURIComponent(this.$config.cjEnterpriseId)}`
                + `&ITEM1=${encodeURIComponent(order.ticket.id)}`
                + `&AMT1=${encodeURIComponent(order.payment.paid)}`
                + `&QTY1=${encodeURIComponent(order.ticket.quantity)}`
                + `&CJEVENT=${encodeURIComponent(this.$store.state.cjEventId)}`
                + `&CID=${encodeURIComponent(this.$config.cjEnterpriseId)}`
                + `&OID=${encodeURIComponent(order.id)}`
                + `&TYPE=${encodeURIComponent(order.customer.is_new ? CJ_NEW_USER_TYPE_ID : CJ_RETURNING_USER_TYPE_ID)}`
                + `&CURRENCY=${encodeURIComponent(order.payment.currency)}`"
            name="Conversion"
            tag
        >
        </iframe>
    </div>
</template>
<script>
import allianzLogo from '../components/AllianzLogo.vue'
import OrderCard from '../components/OrderCard.vue'
import quebecUserModal from '../mixins/QuebecUserModal'
import trackable from '../mixins/Trackable'

const INSURANCE_PEDNING_STATUS = 'PENDING'

export default {
    beforeCreate () {
        this.htmlPageTitle = `Order Confirmation at ${this.$config.partnerName}`
    },
    components: {
        allianzLogo,
        OrderCard
    },
    computed: {
        hasOptedInInsurance () {
            return this.order && this.order.insurance && this.order.insurance.status && this.order.insurance.status === INSURANCE_PEDNING_STATUS
        },
        isCjTrackingPixel () {
            return Boolean(this.$store.state.cjEventId && this.order && this.$config.cjEnterpriseId)
        },
        trackingPixelHtml () {
            if (!this.$config.trackingPixel) { return }
            if (!this.order) { return }
            return (this.$config.trackingPixel).replace('ORDER_ID', String(this.order.id)).replace('ORDER_SUBTOTAL', String(this.order.ticket.pricing.subtotal))
        }
    },
    data () {
        return {
            order: null
        }
    },
    created () {
        this.order = this.$store.state.orderConfirmation
        this.trackableEventCategory = 'UX - Confirmation'
        this.CJ_NEW_USER_TYPE_ID = 408545
        this.CJ_RETURNING_USER_TYPE_ID = 408546

        if (this.order) {
            this.trackPageViewEvent('Confirmation - Pageview')
            this.trackPageView(this.$route.fullPath, this.htmlPageTitle)
        } else {
            this.$router.replace({ path: '/not-found' })
        }
    },
    head: {
        title () {
            return {
                inner: this.htmlPageTitle
            }
        }
    },
    mixins: [
        quebecUserModal,
        trackable
    ]
}
</script>

<style lang="postcss" scoped>
@import "theme";

h2 {
    color: var(--c-primary);
}

.allianz-logo {
    height: 23px;
}

.insurance-confirmation {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 0 2px rgba(0,0,0,.5);
    display: -ms-flexbox;
    display: flex;
    margin-top: 16px;
    overflow: hidden;
    padding: 16px;

    & .insurance-confirmation__logo {
        -ms-flex-preferred-size: 128px;
        flex-basis: 128px;
        -ms-flex-negative: 0;
        flex-shrink: 0;
    }

    & .insurance-confirmation__info {
        -ms-flex-preferred-size: 100%;
        flex-basis: 100%;
        -ms-flex-positive: 1;
        flex-grow: 1;
        -ms-flex-negative: 1;
        flex-shrink: 1;

        & p {
            margin: 0;
        }
    }
}

.order {
    background: white;
    border-radius: 4px;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.3);
    max-width: 896px;
    overflow: hidden;

    & .order__card {
        margin: 0 auto;
        max-width: 686px;
    }
}

.page {
    margin: 32px auto;
    max-width: 928px;
    padding: var(--site-padding);
    width: 100%;
}
</style>
